<template>

<footer id="footer" class="footer dark-background">
    <div class="container copyright text-center mt-4">
      <p>© <span>Copyright</span> <strong class="px-1 sitename">E-SOGEMA</strong> <span>Tous droits réservés</span></p>
      <div class="credits">
        Conçu par <a href="https://romastechnologie.com/">ROMAS</a>
      </div>
    </div>
  </footer>
  <!-- Scroll Top -->
  <a href="#" id="scroll-top" class="scroll-top d-flex align-items-center justify-content-center"><i class="bi bi-arrow-up-short"></i></a>
</template>
<script lang="ts">
import { defineComponent, onMounted } from "vue";

export default defineComponent({
  name: "FooterV",
  components: {},
  setup() {
    //
  },
});
</script>